import { Typography } from '@material-ui/core'
import { Box, SwipeableDrawer } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ModalWindow from '../UI/ModalWindow'
import Feedback from './Feedback'
import FeedBackModule from './FeedBackModule'
import '../../assets/scss/FeedbackModule.scss'
import { URL } from '../../utils/Constants'
import { axiosPost } from '../../utils/AxiosApi'

const FeedbackBadge = () => {
  const [widgetModalOpen, setWidgetModalOpen] = useState(false);

  const closeWidgetModal = () => {
    setWidgetModalOpen(false);
  };
  const openWidgetModal = () => {
    setWidgetModalOpen(true);
  };
  const onSubmitFeedback = (data) => {
    console.log("Feedback submitted:", data);
    closeWidgetModal();
  }
  const onCancelFeedback = (data) => {
    console.log("Feedback cancelled:", data);
    closeWidgetModal();
  }

  const modalTitle = "We value your Feedback";
  return (
    <>
   <Box
    onClick={openWidgetModal}
    className="feedback-badge"
    >
    <Typography variant="caption" fontWeight="bold">
      FEEDBACK
    </Typography>
  </Box>
  <ModalWindow
                backdrop="static"
                keyboard={false}
                fullWidth={false}
                modal={widgetModalOpen}
                toggleModal={closeWidgetModal}
                noModelHeader={true}
                // modalHeader={modalTitle}
                modalBody={
                    // <FeedBackModule
                    // onSubmit={onSubmitFeedback}
                    // onCancel={onCancelFeedback}
                    // />
                    <Feedback
                    handleCancel={onCancelFeedback}
                    />
                }
            />
    </>
  )
}

export default FeedbackBadge